import {showErrorNotification, showSuccessNotification} from '../global/notifications';
import {resources} from "../../constants/string-resources";

const $pcoGrid = $('#pcoDetailGrid');

const _contract = $('#Contract').val();
const _company = $('#Company').val();
const _$currentUser = $('#currentUser');
const _currentUser = Number(_$currentUser.val());
const _isAdmin = _$currentUser.data('is-admin');
const _isProjectManager = _$currentUser.data('is-project-manager');
export default function () {
    if ($pcoGrid.length) initGrid();

    attachLegalReviewChangeEvent();
}

const initGrid = () => {
    $pcoGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: [
            {
                field: 'PcoDate', title: 'PCO Date', attributes: {class: ''}, type: 'date', format: '{0: M/d/yyyy}'
            }, {
                field: 'Status', title: 'PCO Status', attributes: {class: ''}, type: 'string'
            }, {
                field: 'Id', title: 'PCO', attributes: {class: ''}, template: function (dataItem) {
                    return `<div>${dataItem.Id} - ${dataItem.Description}<span class='k-icon k-i-attachment-45' data-kendoWindow="ViewpointAttachments" data-role="openKendoWindow" data-pco="${dataItem.Id}" style="margin-left:5px;"></span></div>`;
                }
            }, {
                field: 'Amount', title: 'Amount', attributes: {class: ''}, type: 'number', format: '{0:n2}'
            }, {
                field: 'GpPercent',
                title: 'GP %',
                attributes: {class: ''},
                type: 'number', template: function (dataItem) {
                    return `<div data-gp-percent="${dataItem.GpPercent}" data-gp-percent-diff="${dataItem.GpPercentDiff}">${kendo.format('{0:P2}', dataItem.GpPercent / 100)}</div>`;
                }
            }, {
                field: 'PmOmChecklist',
                title: 'Required Documentation',
                attributes: {class: ''},
                template: function (dataItem) {
                    return `<div style="text-align: center; width: 100%;"><div class="k-button js-pm-om-checklist ${dataItem.EstimateAttached ? 'k-green' : 'k-red'}" data-pco="${dataItem.Id}" data-status="${dataItem.Status}" data-amount="${dataItem.Amount}" data-cost="${dataItem.Cost}" data-kendoWindow="PmOmChecklistModal" data-role="openKendoWindow">Verification Required</div></div>`;
                }
            }, {
                field: 'Approvals',
                title: 'Approvals',
                attributes: { class: '' },
                template: function (dataItem) {
                    let output = '';

                    if (dataItem.HasComments) {
                        output += `<span class="icon icon--comment-has js-comment-history" data-pco="${dataItem.Id}" data-role="openKendoWindow" data-kendoWindow="PcoCommentHistoryModal" style="position: absolute; top: 10px; right: 10px; cursor: pointer"></span>`;
                    }

                    dataItem.Approvals.forEach(item => {
                        output += getApprovalTag(item.Title, item.Approval);
                    })

                    return output;
                },
                filterable: {
                    extra: false,
                    operators: {
                        object: {
                            neq: "Needs"
                        }
                    },
                    ui: approvalFilter
                }
            }
        ], dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'aid', fields: {
                        PcoDate: {editable: false, type: 'date'},
                        Status: {editable: false, type: 'string'},
                        Id: {editable: false, type: 'string'},
                        Amount: {editable: false, type: 'number'},
                        ContractAmount: {editable: false, type: 'number'},
                        ContractQuarterAmount: {editable: false, type: 'number'},
                        Cost: {editable: false, type: 'number'},
                        GpPercent: {editable: false, type: 'number'},
                        ProjectGpPercent: {editable: false, type: 'number'},
                        GpPercentDiff: {editable: false, type: 'number'},
                        PmOmChecklist: {editable: false, type: 'boolean'},
                        EstimateAttached: {editable: false, type: 'boolean'},
                        HasComments: {editable: false, type: 'boolean'},
                        ProjectManager: {editable: false, type: 'object'},
                        IntendedProjectManager: {editable: false, type: 'number'},
                        Finance: {editable: false, type: 'object'},
                        OperationsManager: {editable: false, type: 'object'},
                        BranchManager: {editable: false, type: 'object'},
                        BranchManagerRequired: {editable: false, type: 'boolean'},
                        RegionalManager: {editable: false, type: 'object'},
                        RegionalManagerRequired: {editable: false, type: 'boolean'},
                        COO: {editable: false, type: 'object'},
                        COORequired: {editable: false, type: 'boolean'},
                        CEO: {editable: false, type: 'object'},
                        CEORequired: {editable: false, type: 'boolean'},
                        Approvals: {editable: false, type: 'object', defaultValue: ''},
                        IsFullyApproved: {editable: false, type: 'boolean'},
                    }
                }
            }, transport: {
                read: {
                    url: '/Operations/PcoApproval/GetPcoDetailInfo', type: 'GET', dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        rs['company'] = $('#Company').val();
                        rs['contract'] = $('#Contract').val();
                        return rs;
                    }
                }
            }
        }, dataBound: function (arg) {
            const k_grid = arg.sender;
            setGpPercentBackGround();
            attachChecklistClickEvent();
            setupCommentButtons();

            let data = k_grid._data,
                forUser = data.find(obj => obj.IntendedProjectManager === _currentUser) != null,
                isForIntendedPm = (forUser && _isProjectManager),
                inOtherApprovalRole = !_isProjectManager,
                userCanApprove = isForIntendedPm || inOtherApprovalRole || _isAdmin;
            if (data.length && userCanApprove) {
                //Show grid if there is data AND
                // the user is a pm and the grid is intended for them
                //     or they are not a PM, i.e., they are in some other approval role
                //     or they are an admin user
                $('.js-grid-response').show();
            }

            $('[role="gridcell"]').css('position', 'relative');
            $(document).trigger('on:PageUpdate');
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: true, editable: true, columnMenu: false,
        filter: function (e) {
            if (e.filter == null) {
            } else {
                const field = e.filter.filters[0].field
                if (field === 'Approvals') {
                    /*Properly filter approvals*/
                    const value = e.filter.filters[0].value
                    const k_pcoGrid = $pcoGrid.data('kendoGrid');
                    k_pcoGrid.dataSource.filter(JSON.parse(value));
                }
            }
        },
        filterMenuInit: function (e) {
            if (e.field === 'Approvals') {
                const k_grid = e.sender;
                e.container.on("click", "[type='reset']", function () {
                    k_grid.dataSource.filter(null);
                });
            }
        }
    });
}

const getApprovalTag = (role, approvalData) => {
    if (approvalData)
        return `<div class="t-green">${approvalData.FullName}</div>`;
    return `<div class="t-red">${role}</div>`;
}

const approvalFilter = (element) => {
    element.kendoDropDownList({
        dataSource: [
            {
                name: 'Project Manager Approval',
                value: JSON.stringify({field: 'ProjectManager', operator: 'eq', value: null})
            },
            {name: 'Finance Approval', value: JSON.stringify({field: 'FinanceRequired', operator: 'eq', value: true})},
            {
                name: 'Ops Manager Approval',
                value: JSON.stringify({field: 'OperationsManager', operator: 'eq', value: null})
            },
            {
                name: `${resources.PositionTitles.BranchManager} Approval`,
                value: JSON.stringify({field: 'BranchManagerRequired', operator: 'eq', value: true})
            },

            {
                name: 'Regional Manager Approval',
                value: JSON.stringify({field: 'RegionalManagerRequired', operator: 'eq', value: true})
            },
            {
                name: `${resources.PositionTitles.RegionalPresident} Approval`,
                value: JSON.stringify({field: 'COORequired', operator: 'eq', value: true})
            },
            {
                name: `${resources.PositionTitles.ChiefExecutiveOfficer} Approval`,
                value: JSON.stringify({field: 'CEORequired', operator: 'eq', value: true})
            }
        ],
        dataTextField: "name",
        dataValueField: "value",
        optionLabel: "--Select Value--"
    });
}

const setGpPercentBackGround = () => {
    const $gpPercents = $('td[data-field="GpPercent"]');

    $.each($gpPercents, function (index, ele) {
        const $amount = $(ele).find('[data-gp-percent]');
        if ($amount.length && Math.abs($amount.data('gp-percent-diff')) > 3) {
            $(ele).addClass('bg-danger-light')
        }
    })
}
const attachLegalReviewChangeEvent = () => {
    const $legalCheckbox = $('input#legal-review');
    if ($legalCheckbox.length) {
        $legalCheckbox.on('change', function () {
            const data = {
                company: _company,
                contract: _contract,
                legalReviewRequired: $legalCheckbox.prop('checked')
            }
            saveLegalReviewStatus(data)
                .then((response) => showSuccessNotification(response))
                .catch((error) => showErrorNotification(error));
        })
    }
}
const saveLegalReviewStatus = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/PcoApproval/SaveLegalReviewStatus', data, function (response) {
            if (response) {
                resolve('Legal Review Status Updated');
            } else {
                reject('Legal Review Status Not Updated')
            }
        })
    })
}

const attachChecklistClickEvent = () => {
    const $checklistButtons = $('.js-pm-om-checklist');

    if ($checklistButtons.length) {
        $checklistButtons.unbind('click');
        $checklistButtons.removeClass('bound');
        $checklistButtons.on('click', function () {
            $('#PmOmChecklistModal').data('pco', $(this).data('pco'))
        })
    }
}

const setupCommentButtons = () => {
    $('[data-field="Approvals"]').css('position', 'relative');
}
